import React from "react";
import "./pagination.scss";
import { ArrowLeft, ArrowRight } from "assets";

/**
 * @param {"default"|"compact"} variant  `compact` untuk tabel kecil di dalam
 *   kartu: tanpa teks Previous/Next dan hanya menampilkan nomor halaman aktif.
 */
const Pagination = ({ isPage, isTotalPage, handleClickNumber, pageToShow, variant = "default" }) => {
  const isCompact = variant === "compact";
  // kurang disabled bnext button, karena arrow right belum di hapus stroke di file svgnya
  const calculatePageRange = () => {
    let startPage, endPage;
  
    if (isTotalPage <= pageToShow) {
      startPage = 1;
      endPage = isTotalPage;
    } else if (isPage <= Math.floor(pageToShow / 2) + 1) {
      startPage = 1;
      endPage = pageToShow;
    } else if (isPage >= isTotalPage - Math.floor(pageToShow / 2)) {
      startPage = isTotalPage - pageToShow + 1;
      endPage = isTotalPage;
    } else {
      startPage = isPage - Math.floor(pageToShow / 2);
      endPage = isPage + Math.floor(pageToShow / 2);
    }
  
    return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
  }

  const pageRange = calculatePageRange()

  if (isTotalPage)
    return (
      <div className={`pagination-container ${isCompact ? "pagination-compact" : ""}`}>
        <div className="page-info">{`Page ${isPage} of ${isTotalPage}`}</div>
        <div className="page-list">
          <button
            className="prev-button"
            aria-label="Halaman sebelumnya"
            disabled={isPage - 1 === 0 ? true : false}
            onClick={() => handleClickNumber(isPage - 1)}
          >
            <ArrowLeft
              stroke={isPage - 1 === 0 ? "var(--text-placeholder)" : "var(--text-primary)"}
              width={20}
              height={20}
            />
            {!isCompact && " Previous"}
          </button>
          {isCompact ? (
            <span className="page-number page-number-active" aria-current="page">
              {isPage}
            </span>
          ) : pageRange.length > 0 &&
            pageRange.map((pageNumber) => (
              <button
                key={pageNumber}
                className={`page-number ${pageNumber === isPage ? "page-number-active" : ""}`}
                onClick={() => handleClickNumber(pageNumber)}
              >
                {pageNumber}
              </button>
            ))}
          <button
            className="next-button"
            aria-label="Halaman berikutnya"
            disabled={isPage === isTotalPage ? true : false}
            onClick={() => handleClickNumber(isPage + 1)}
          >
            {!isCompact && "Next "}
            <ArrowRight
              stroke={isPage === isTotalPage ? "var(--text-placeholder)" : "var(--text-strong)"}
            />
          </button>
        </div>
      </div>
    );
};

export default Pagination;
